
// "use client";
// import logo2 from "../../Assets/logo2.png";
// import logo from "../../Assets/logo-horizontal-full2.png";
// import hamburgericon from "../../Assets/menu2.png";
// import React, { useState } from "react";
// import { Settings, ShoppingCart } from "react-feather";
// import { useSelector ,useDispatch} from "react-redux";
// import { clearCart, } from "../../Redux/slices/cartSlice";
// import Cart from "../Cart"; // Import the Cart component

// export default function Header({ toggle }) {
//   const { totalQuantity } = useSelector((state) => state.cart);
//   const dispatch = useDispatch();
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [isCartOpen, setIsCartOpen] = useState(false);

//   const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
//   const toggleCart = () => setIsCartOpen(!isCartOpen);

//   const user_details = JSON.parse(localStorage.getItem("user_details"));

//   const handleLogout = () => {
//     localStorage.removeItem("mmt_front_token");
//     localStorage.removeItem("user_details");
//     dispatch(clearCart());
//     window.location.href = "/login";
//   };

//   return (
//     <nav className="flex items-center justify-between shadow-md py-1 px-5 mb-1">
//       <div className="flex items-center justify-between" style={{ width: "15%" }}>
//         <img src={logo} style={{ width: "80%", marginRight: "5%" }} alt="" />
//         <img
//           src={hamburgericon}
//           style={{ width: "20%", height: "70%" }}
//           alt=""
//           onClick={() => {
//             toggle();
//           }}
//         />
//       </div>

//       <div className="text-2xl inter font-semibold"> Build a Tool </div>

//       <div className="relative w-52 flex gap-3">
//         <div>
//           <button className="p-0 rounded-lg text-black">
//             {`Welcome ${user_details?.username || "Guest"}`}
//           </button>
//         </div>

//         <div className="relative flex items-center">
//           <ShoppingCart
//             className="cursor-pointer"
//             size={25}
//             color="#807e7ed7"
//             onClick={toggleCart}
//           />
//           {totalQuantity > 0 && (
//             <span className="absolute -top-1 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-4 h-4 flex items-center justify-center">
//               {totalQuantity}
//             </span>
//           )}
//         </div>

//         <div>
//           <Settings
//             className="cursor-pointer"
//             size={25}
//             color="#807e7ed7"
//             onClick={toggleDropdown}
//           />
//         </div>

//         {isDropdownOpen && (
//           <div
//             style={{ top: "20px" }}
//             className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 rounded-lg shadow-lg"
//           >
//             <a
//               href="#"
//               className="block px-4 py-2 text-gray-700 hover:bg-gray-200"
//             >
//               Account Settings
//             </a>
//             <a
//               onClick={handleLogout}
//               className="block px-4 py-2 text-gray-700 hover:bg-gray-200"
//             >
//               Logout
//             </a>
//           </div>
//         )}
//         {isCartOpen && <Cart onClose={() => setIsCartOpen(false)} />}
//       </div>
//     </nav>
//   );
// }

"use client";
import logo from "../../Assets/MMT_Green_Black.png";
import hamburgericon from "../../Assets/menu2.png";
import React, { useState } from "react";
import { Settings, ShoppingCart } from "react-feather";
import { useSelector, useDispatch } from "react-redux";
import { clearCart } from "../../Redux/slices/cartSlice";
import Cart from "../Cart"; // Import the Cart component

export default function Header({ toggle }) {
  const { totalQuantity } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const toggleCart = () => setIsCartOpen(!isCartOpen);

  const user_details = JSON.parse(localStorage.getItem("user_details"));

  const handleLogout = () => {
    localStorage.removeItem("mmt_front_token");
    localStorage.removeItem("user_details");
    dispatch(clearCart());
    window.location.href = "/login";
  };

  return (
    <nav className="grid grid-cols-3 items-center shadow-md py-4 px-4 sm:px-8 bg-white sticky top-0 z-50">
      {/* Left Section: Logo and Hamburger */}
      <div className="flex items-center gap-4">
        <img
          src={logo}
          className="w-2/5 max-w-[50%] hidden sm:block"
          alt="Logo"
        />
        <img
          src={hamburgericon}
          className="w-5 max-w-[10%] h-5 sm:w-6 sm:h-6 cursor-pointer"
          alt="Menu"
          onClick={toggle}
        />
      </div>

      {/* Middle Section: Title */}
      <div className="text-center text-lg sm:text-xl md:text-2xl font-semibold">
        Build a Tool
      </div>

      {/* Right Section: User Info and Actions */}
      <div className="flex items-center gap-4 justify-end relative">
        <button className="text-black font-medium hidden sm:block">
          {`Welcome ${user_details?.username || "Guest"}`}
        </button>

        <div className="relative flex items-center">
          <ShoppingCart
            className="cursor-pointer"
            size={20}
            color="#807e7ed7"
            onClick={toggleCart}
          />
          {totalQuantity > 0 && (
            <span className="absolute -top-1 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-4 h-4 flex items-center justify-center">
              {totalQuantity}
            </span>
          )}
        </div>

        <Settings
          className="cursor-pointer"
          size={20}
          color="#807e7ed7"
          onClick={toggleDropdown}
        />

        {/* Dropdown Menu */}
        {isDropdownOpen && (
          <div
            className="absolute top-full right-0 mt-2 w-48 bg-white border border-gray-300 rounded-lg shadow-lg z-50"
          >
            <a
              href="#"
              className="block px-4 py-2 text-gray-700 hover:bg-gray-200"
            >
              Account Settings
            </a>
            <a
              onClick={handleLogout}
              className="block px-4 py-2 text-gray-700 hover:bg-gray-200 cursor-pointer"
            >
              Logout
            </a>
          </div>
        )}
      </div>

      {/* Cart Modal */}
      {isCartOpen && <Cart onClose={() => setIsCartOpen(false)} />}
    </nav>
  );
}
